<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-3">
        <h4 class="mt-4 mb-4 ml-3 fw-bold d-none d-lg-block">Filters</h4>
        <div
            class="offcanvas-lg offcanvas-start"
            tabindex="-1"
            id="offcanvasResponsive"
            aria-labelledby="offcanvasResponsiveLabel"
        >
          <div class="offcanvas-header">
            <h5 class="offcanvas-titl fw-bold" id="offcanvasResponsiveLabel">
              Filters
            </h5>
            <button
                type="button"
                class="btn-close"
                data-bs-dismiss="offcanvas"
                data-bs-target="#offcanvasResponsive"
                aria-label="Close"
            ></button>
          </div>

          <VueMultiselect
              class="shop-search-input"
              v-model="selectedSearch"
              :select-label="''"
              :options="options"
              :close-on-select="true"
              :clear-on-select="true"
              :hide-selected="true"
              :internal-search="false"
              :allow-empty="true"
              :block-keys="['Tab']"
              open-direction="bottom"
              placeholder="Search by name or Item #"
              @search-change="asyncSearch"
              label="Code"
              track-by="Code"
              @keydown.enter.capture.prevent="preventEnter"
              :loading="isLoading"
          >
            <template v-slot:option="{ option }">
              <b>{{ option.Code }}</b>
              <br/>
              <span>{{ option.Description }}</span>
            </template>
            <template #noResult>
              No products found
            </template>
          </VueMultiselect>

          <div class="offcanvas-body">
            <div
                class="accordion accordion-flush products-filter"
                id="accordionFlushExample"
            >
              <div class="accordion-item" v-if="isLoggedin">
                <h2 class="accordion-header" id="flush-headingFP">
                  <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseFP"
                      aria-expanded="false"
                      aria-controls="flush-collapseFP"
                      @click="getFrequentlyPurchased()"
                  >
                    Frequently Purchased
                  </button>
                </h2>
                <div
                    id="flush-collapseFP"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingFP"
                >
                  <div class="accordion-body" style="padding:0;">

                  </div>
                </div>
              </div>

              <div class="accordion-item" v-show="!filters.isFC && filters.isFC !== undefined">
                <h2 class="accordion-header" id="flush-headingEight">
                  <button
                      class="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseEight"
                      aria-expanded="false"
                      aria-controls="flush-collapseEight"
                  >
                    Products
                  </button>
                </h2>
                <div
                    id="flush-collapseEight"
                    class="accordion-collapse collapse show"
                    aria-labelledby="flush-headingEight"
                >
                  <div class="accordion-body">
                    <div
                        class="form-check"
                        v-for="type in orderedTypeOptions"
                        :key="type.value"
                    >
                      <input
                          class="form-check-input"
                          type="radio"
                          name="flt_width"
                          v-model="filters.type"
                          :value="[type.value]"
                          :id="'defaultCheck_'+type.value"
                      />
                      <label
                          class="form-check-label"
                          :for="'defaultCheck_'+type.value"
                      >
                        {{ type.name }}
                      </label>
                      <div
                          v-if="parseInt(filters.type[0]) === parseInt(type.value) && getSubcategoriesForType(type).length > 0"
                          class="ms-3 mt-2"
                      >
                        <div
                            class="form-check"
                            v-for="subcategory in getSubcategoriesForType(type)"
                            :key="subcategory.id"
                        >
                          <input
                              class="form-check-input"
                              type="checkbox"
                              name="flt_subcategory"
                              v-model="filters.subcategory"
                              :value="subcategory.id"
                              :id="'defaultSubcategory_' + subcategory.id"
                          />
                          <label
                              class="form-check-label"
                              :for="'defaultSubcategory_' + subcategory.id"
                          >
                            {{ subcategory.name + ' (' + getSubcategoryCount(subcategory) + ')' }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="accordion-item" v-show="showCollectionFilter">
                <h2 class="accordion-header" id="flush-headingThree">
                  <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseThree"
                      aria-expanded="false"
                      aria-controls="flush-collapseThree"
                  >
                    Collection
                  </button>
                </h2>
                <div
                    id="flush-collapseThree"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingThree"
                >
                  <div class="accordion-body">
                    <div
                        class="form-check"
                        v-for="filtersData in availableFilters.collection"
                        :key="filtersData.id"
                    >
                      <input
                          class="form-check-input"
                          type="checkbox"
                          name="flt_width"
                          v-model="filters.collection"
                          :value="filtersData.id"
                          :id="'defaultColl_'+filtersData.id"
                      />
                      <label
                          class="form-check-label"
                          :for="'defaultColl_'+filtersData.id"
                      >
                        {{ filtersData.name + ' (' + (availableFilters.collectionCount[filtersData.id] || 0) + ')' }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>


              <div class="accordion-item" v-show="showThicknessFilter">
                <h2 class="accordion-header" id="flush-headingTwelve">
                  <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseTwelve"
                      aria-expanded="false"
                      aria-controls="flush-collapseTwelve"
                  >
                    Thickness
                  </button>
                </h2>
                <div
                    id="flush-collapseTwelve"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingTwelve"
                >
                  <div class="accordion-body">
                    <div
                        class="form-check"
                        v-for="filtersData in sortedThicknessOptions"
                        :key="'thickness_' + filtersData.id"
                    >
                      <input
                          class="form-check-input"
                          type="checkbox"
                          name="flt_thickness"
                          v-model="filters.thickness"
                          :value="filtersData.id"
                          :id="'defaultThickness_' + filtersData.id"
                      />
                      <label
                          class="form-check-label"
                          :for="'defaultThickness_' + filtersData.id"
                      >
                        {{ filtersData.name + ' (' + getBasicFilterCount('thicknessCount', filtersData) + ')' }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="accordion-item" v-show="showDimensionsFilter">
                <h2 class="accordion-header" id="flush-headingThirteen">
                  <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseThirteen"
                      aria-expanded="false"
                      aria-controls="flush-collapseThirteen"
                  >
                    Size
                  </button>
                </h2>
                <div
                    id="flush-collapseThirteen"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingThirteen"
                >
                  <div class="accordion-body">
                    <div
                        class="form-check"
                        v-for="filtersData in normalizeBasicFilterRows(availableFilters.dimensions)"
                        :key="'dimensions_' + filtersData.id"
                    >
                      <input
                          class="form-check-input"
                          type="checkbox"
                          name="flt_dimensions"
                          v-model="filters.dimensions"
                          :value="filtersData.id"
                          :id="'defaultDimensions_' + filtersData.id"
                      />
                      <label
                          class="form-check-label"
                          :for="'defaultDimensions_' + filtersData.id"
                      >
                        {{ filtersData.name + ' (' + getBasicFilterCount('dimensionsCount', filtersData) + ')' }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="accordion-item" v-show="showAcidFreeFilter">
                <h2 class="accordion-header" id="flush-headingFourteen">
                  <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseFourteen"
                      aria-expanded="false"
                      aria-controls="flush-collapseFourteen"
                  >
                    Acid Free
                  </button>
                </h2>
                <div
                    id="flush-collapseFourteen"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingFourteen"
                >
                  <div class="accordion-body">
                    <div class="mb-2">
                      <button
                          type="button"
                          class="btn btn-link p-0 text-decoration-none"
                          @click="clearAcidFreeFilter"
                      >
                        Clear
                      </button>
                    </div>
                    <div class="form-check">
                      <input
                          class="form-check-input"
                          type="radio"
                          name="flt_acid_free"
                          id="defaultAcidFree_yes"
                          :checked="parseInt(filters.acid_free[0]) === 1"
                          @change="setAcidFreeFilter(1)"
                      />
                      <label class="form-check-label" for="defaultAcidFree_yes">
                        Yes
                      </label>
                    </div>
                    <div class="form-check">
                      <input
                          class="form-check-input"
                          type="radio"
                          name="flt_acid_free"
                          id="defaultAcidFree_no"
                          :checked="parseInt(filters.acid_free[0]) === 0"
                          @change="setAcidFreeFilter(0)"
                      />
                      <label class="form-check-label" for="defaultAcidFree_no">
                        No
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="accordion-item" v-show="showWidthFilter">
                <h2 class="accordion-header" id="flush-headingOne">
                  <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseOne"
                      aria-expanded="false"
                      aria-controls="flush-collapseOne"
                  >
                    Width
                  </button>
                </h2>
                <div
                    id="flush-collapseOne"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingOne"
                >
                  <div class="accordion-body">
                    <width-select-box @selected="handleSetWidth"></width-select-box>
                  </div>
                </div>
              </div>
              <div class="accordion-item" v-show="showHeightFilter">
                <h2 class="accordion-header" id="flush-headingNine">
                  <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseNine"
                      aria-expanded="false"
                      aria-controls="flush-collapseNine"
                  >
                    Height
                  </button>
                </h2>
                <div
                    id="flush-collapseNine"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingNine"
                >
                  <div class="accordion-body">
                    <width-select-box @selected="handleSetHeight"></width-select-box>
                  </div>
                </div>
              </div>
              <div class="accordion-item" v-show="showRabbetFilter">
                <h2 class="accordion-header" id="flush-headingTwo">
                  <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseTwo"
                      aria-expanded="false"
                      aria-controls="flush-collapseTwo"
                  >
                    Rabbet Depth
                  </button>
                </h2>
                <div
                    id="flush-collapseTwo"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingTwo"
                >
                  <div class="accordion-body">
                    <width-select-box @selected="handleSetRabbet"></width-select-box>
                  </div>
                </div>
              </div>

              <div class="accordion-item" v-show="showFinishFilter">
                <h2 class="accordion-header" id="flush-headingFive">
                  <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseFive"
                      aria-expanded="false"
                      aria-controls="flush-collapseFive"
                  >
                    Finish Type
                  </button>
                </h2>
                <div
                    id="flush-collapseFive"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingFive"
                >
                  <div class="accordion-body">
                    <div
                        class="form-check"
                        v-for="finish in availableFilters.finish"
                        :key="finish.value"
                    >
                      <input
                          class="form-check-input"
                          type="checkbox"
                          name="flt_width"
                          v-model="filters.finish"
                          :value="finish.value"
                          :id="'defaultFinish_'+finish.value"
                      />
                      <label
                          class="form-check-label"
                          :for="'defaultFinish_'+finish.value"
                      >
                        {{ finish.name + ' (' + finish.count + ')' }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="accordion-item" v-show="showStyleFilter">
                <h2 class="accordion-header" id="flush-headingSeven">
                  <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseSeven"
                      aria-expanded="false"
                      aria-controls="flush-collapseSeven"
                  >
                    Style
                  </button>
                </h2>
                <div
                    id="flush-collapseSeven"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingSeven"
                >
                  <div class="accordion-body">
                    <div
                        class="form-check"
                        v-for="style in availableFilters.style"
                        :key="style.value"
                    >
                      <input
                          class="form-check-input"
                          type="checkbox"
                          name="flt_width"
                          v-model="filters.style"
                          :value="style.value"
                          :id="'defaultStyle_'+style.value"
                      />
                      <label
                          class="form-check-label"
                          :for="'defaultStyle_'+style.value"
                      >
                        {{ style.name + ' (' + style.count + ')' }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="accordion-item" v-show="showColorFamilyFilter">
                <h2 class="accordion-header" id="flush-headingTen">
                  <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseTen"
                      aria-expanded="false"
                      aria-controls="flush-collapseTen"
                  >
                    Color Family
                  </button>
                </h2>
                <div
                    id="flush-collapseTen"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingTen"
                >
                  <div class="accordion-body">
                    <div
                        class="form-check"
                        v-for="filtersData in availableFilters.color_family"
                        :key="filtersData.id"
                    >
                      <input
                          class="form-check-input"
                          type="checkbox"
                          name="flt_width"
                          v-model="filters.color_family"
                          :value="filtersData.id"
                          :id="'defaultColor_'+filtersData.id"
                      />
                      <label
                          class="form-check-label"
                          :for="'defaultColor_'+filtersData.id"
                      >
                        {{ filtersData.name + ' (' + (availableFilters.colorFamilyCount[filtersData.id] || 0) + ')' }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="accordion-item" v-show="showProfileTypeFilter">
                <h2 class="accordion-header" id="flush-headingEleven">
                  <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseEleven"
                      aria-expanded="false"
                      aria-controls="flush-collapseEleven"
                  >
                    Profile Type
                  </button>
                </h2>
                <div
                    id="flush-collapseEleven"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingEleven"
                >
                  <div class="accordion-body">
                    <div
                        class="form-check"
                        v-for="filtersData in availableFilters.profile_type"
                        :key="filtersData.id"
                    >
                      <input
                          class="form-check-input"
                          type="checkbox"
                          name="flt_width"
                          v-model="filters.profile_type"
                          :value="filtersData.id"
                          :id="'defaultProfile_'+filtersData.id"
                      />
                      <label
                          class="form-check-label"
                          :for="'defaultProfile_'+filtersData.id"
                      >
                        {{ filtersData.name + ' (' + (availableFilters.profileTypeCount[filtersData.id] || 0) + ')' }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-9 mt-4 mb-4">
        <button
            class="btn btn-primary d-lg-none"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasResponsive"
            aria-controls="offcanvasResponsive"
        >
          View Filters
        </button>
        <div class="row">
          <div v-for="(value, key, index) in nonEmptyFilters" :key="index">
            <div class="col" v-if="value.length > 0 && isArray(value)">
              <span
                  class=" badge rounded-pill text-bg-light mb-3 p-2 text-uppercase shadow-sm border-secondary"
                  v-for="selFilters in value"
                  :key="selFilters"
              >
                {{ filterLabel(key) + ": " + filterByValue(key, selFilters) }}
                <button
                    type="button"
                    class="btn-close"
                    aria-label="Close"
                    v-if="!isFrameBuilder || (key === 'TYPE' && isFrameBuilder)"
                    v-on:click.prevent.stop="removeFilterByValue(key, selFilters)"
                ></button>
              </span>

            </div>
            <div class="col" v-if="value.length > 0 && !isArray(value) && value !== undefined && value !== ''">
              <span
                  class="badge rounded-pill text-bg-light mb-3 p-2 text-uppercase shadow-sm border-secondary"
                  :key="value"
              >
                {{ filterLabel(key) + ": " + value }}
                <button
                    type="button"
                    class="btn-close"
                    aria-label="Close"
                    v-on:click.prevent.stop="removeFilterByValue(key, value)"
                ></button>
              </span>
            </div>
          </div>
        </div>
        <!--
        <RecentPurchase v-if="this.filters.Code === '' && !isFrameBuilder"></RecentPurchase>
        -->
        <div class="row">
          <div class="col text-end">
            Total Results {{ totalResults.toLocaleString() }}
          </div>
        </div>
        <div class="row row-cols-1 row-cols-xl-3 g-4 product-search card-group">
          <div class="col col-lg-4 col-xl-3" v-for="item in productData" :key="item">
            <div class="card card-products shadow-md">
              <div class="card-img">
                <img
                    :src="imageUrl(item)"
                    @error="imageUrlAlt"
                    class="card-img-top img-fluid"
                    alt="..."
                />
              </div>

              <div class="card-body">
                <div class="row">
                  <div class="col text-start">
                    <span class="text-uppercase d-block overflow-x-hidden text-nowrap text-truncate codeFS">#{{
                        item.Code
                      }}</span>
                  </div>
                  <div class="col text-end">
                    <span class="d-block fw-bold" v-if="item.FrameType === 'MOULDING'"
                          v-html="widthFrac(item.Width)"></span>
                  </div>
                </div>
                <div class="row">
                  <div class="col text-start">
                    <span class="d-block fs-5 text subdued overflow-x-hidden text-nowrap text-truncate dispH"
                          :title="item.display_name">
                      {{ item.display_name }}
                    </span>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col text-start">
                    <a href="#" class="btn btn-outline-dark rounded-0 d-block mb-2" @click.prevent="shopDetail(item)">Details</a>
                    <a href="#" class="btn btn-dark rounded-0 d-block"
                       v-if="isLoggedin && !isFrameBuilder"
                       @click.prevent.stop="addToCart(item)">+ Add to Cart</a>
                    <a
                        href="#"
                        class="btn btn-dark rounded-0 d-block"
                        v-if="isFrameBuilder"
                        v-on:click.prevent.stop="frameMouldingBuilder(item)"
                    >Select</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-show="hasMore">
          <div class="col-12 text-center mt-3">
            <button class="btn btn-primary"
                    style="padding-left:50px; padding-right:50px;"
                    @click="loadNextPage()"
            >MORE
            </button>
          </div>
        </div>

        <!--
        <RecentPurchase v-if="this.filters.Code !== '' && !isFrameBuilder"></RecentPurchase>
        -->
        <div class="row">
          <div class="col text-center mt-4" v-show="infShowLoader">
            <div class="spinner-grow text-dark" role="status"></div>
            <div class="spinner-grow text-dark" role="status"></div>
            <div class="spinner-grow text-dark" role="status"></div>
            <div class="spinner-grow text-dark" role="status"></div>
            <div class="spinner-grow text-dark" role="status"></div>
          </div>
        </div>

        <RecentPurchase v-if="!isFrameBuilder"></RecentPurchase>

      </div>
    </div>

    <CartDetails ref="cartD" :detailImg="detailImg" @closeModal="closeModal" @returnData="returnData"></CartDetails>

    <ShopDetails :details="details" :detailData="detailData" :detailImg="detailImg"></ShopDetails>

    <back-order @boRespond="boRespond"></back-order>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Fraction from "fraction.js";
import {Modal} from "bootstrap";
import CartDetails from "@/components/Auth/CartDetails.vue";
import ShopDetails from "@/views/shopDetails.vue";
import VueMultiselect from 'vue-multiselect'
import widthSelectBox from "@/components/widthSelectBox.vue";
import BackOrder from "@/components/Admin/BackOrder.vue";
import RecentPurchase from "@/components/Admin/RecentPurchase.vue";
import FrequentlyPurchased from "@/components/Admin/FrequentlyPurchased.vue";

export default {
  name: "shopView",
  props: ["Code", "searchOptions", "Open"],
  data() {
    return {
      hasMore: true,
      thisSaveItem: {},
      isFrameBuilder: false,
      myModal: null,
      backorderModal: null,
      detailModal: null,
      detailCode: "",
      details: {},
      detailData: {},
      detailImg: "",
      perPage: 50,
      page: 1,
      typeChange: false,
      lastType: '',
      codeOnce: false,
      infShowLoader: false,
      totalResults: 0,
      defaultImg: require("@/assets/images/img-default.png"),
      searchCode: "",
      searchInputTemp: "",
      activeMainSearchKey: "",
      isMainSearchInFlight: false,
      runWatch: true,
      hasOpen: false,
      isLoading: false,
      selectedSearch: "",
      options: [],
      searchTimer: "",
      clearWatch: false,
      suppressAutocompleteSelection: false,
      ignoreAutocompleteResults: false,
      hasQuery: false,
      frequently_purchased_active: false,
      filters: {
        width: [],
        height: [],
        rabbet: [],
        finish: [],
        style: [],
        collection: [],
        thickness: [],
        dimensions: [],
        acid_free: [],
        type: [],
        Code: "",
        TopSearch: "",
        subcategory: [],
        profile_type: [],
        color_family: [],
        frequently_purchased: [],
        isFC: false
      },
    };
  },
  components: {
    CartDetails,
    ShopDetails,
    VueMultiselect,
    widthSelectBox,
    BackOrder,
    RecentPurchase
  },
  watch: {
    // whenever question changes, this function will run
    'filters.type': {
      handler() {
        if (this.runWatch && this.filters.type.length > 0) {
          let curType = this.filters.type[0]
          this.typeChange = true

          this.runWatch = false
          //let self = this
          this.clearFilters(curType, function () {
            //self.searchProducts();
          })

        } else {
          this.runWatch = true
          this.typeChange = false
        }
      }
    },
    filters: {
      handler() {
        let self = this
        //let typeC = this.typeChange
        setTimeout(function () {
          if (self.runWatch) {
            if (!self.typeChange) {
              self.searchProducts();
            }
          }
        }, 600)
      },
      deep: true,
    },
    selectedSearch: {
      handler(newVal) {
        if (this.suppressAutocompleteSelection) {
          this.clearWatch = true
          this.selectedSearch = ''
          return
        }
        if (!this.clearWatch) {
          if (newVal.Code != null && newVal.Code != '') {
            this.isLoading = false
            //this.filters.Code = newVal.Code
            let self = this
            this.clearFilters('', function () {
              self.filters.Code = newVal.Code
              //self.searchProducts();
            })

            //window.location.href = '/#/Shop/' + newVal.Code;
          }
          this.clearWatch = true
          this.selectedSearch = ''
        } else {
          this.clearWatch = false
        }
      },
      deep: true,
    },
    $route() {
      // this will be called any time the route changes
      if (this.Code !== undefined && this.Code !== "") {
        this.filters.type = [];
        this.searchCode = this.Code;
        this.filters.Code = this.Code;
        this.filters.TopSearch = "";
        this.selectedSearch = ''
        return
      }

      let routeSearchTerm = this.getRouteSearchTerm(this.$route)
      if (routeSearchTerm !== '') {
        this.applyGlobalSearch(routeSearchTerm)
      }
    },
  },
  computed: {
    nonEmptyFilters() {
      let objFilter = {}
      let obj = this.filters;
      for (let key in obj) {
        if (Array.isArray(obj[key])) {
          if (obj[key].length > 0) {
            objFilter[key] = obj[key]
          }
        } else {
          if (obj[key] !== "") {
            objFilter[key] = obj[key]
          }
        }
      }

      return objFilter
    },

    FrequentlyPurchased() {
      return FrequentlyPurchased
    },
    ...mapGetters({
      productData: "product/getProducts",
      isLoggedin: "userAccess/isLoggedin",
      availableFilters: "product/getFilterData",
    }),
    orderedTypeOptions() {
      let typeOptions = Array.isArray(this.availableFilters?.type) ? this.availableFilters.type : [];
      let preferredOrder = ['moulding', 'mats', 'glass', 'acrylic', 'hardware', 'foamboard'];
      let orderMap = preferredOrder.reduce((acc, name, index) => {
        acc[name] = index;
        return acc;
      }, {});

      return typeOptions
          .map((type, index) => ({
            type,
            index,
            order: orderMap[this.normalizeTypeName(type?.name)] ?? Number.MAX_SAFE_INTEGER
          }))
          .sort((a, b) => {
            if (a.order !== b.order) {
              return a.order - b.order;
            }
            return a.index - b.index;
          })
          .map((entry) => entry.type);
    },
    sortedThicknessOptions() {
      let options = this.normalizeBasicFilterRows(this.availableFilters?.thickness);
      return [...options].sort((a, b) => {
        let aNum = parseFloat(String(a?.name ?? '').replace(/[^\d.]/g, ''));
        let bNum = parseFloat(String(b?.name ?? '').replace(/[^\d.]/g, ''));
        let aHasNumber = !Number.isNaN(aNum);
        let bHasNumber = !Number.isNaN(bNum);

        if (aHasNumber && bHasNumber && aNum !== bNum) {
          return aNum - bNum;
        }
        if (aHasNumber !== bHasNumber) {
          return aHasNumber ? -1 : 1;
        }
        return String(a?.name ?? '').localeCompare(String(b?.name ?? ''));
      });
    },
    selectedType() {
      let selectedTypeValue = this.filters.type[0];
      let typeOptions = Array.isArray(this.availableFilters?.type) ? this.availableFilters.type : [];
      return typeOptions.find((type) => parseInt(type.value) === parseInt(selectedTypeValue));
    },
    isMatsSelected() {
      return this.normalizeTypeName(this.selectedType?.name).includes('mat');
    },
    showProfileTypeFilter() {
      return this.filters.type[0] !== 1 &&
          this.filters.type[0] !== 2 &&
          this.filters.type[0] !== 3 &&
          this.filters.type[0] !== 6 &&
          this.filters.type[0] !== 13 &&
          this.filters.type[0] !== 14
    },
    showColorFamilyFilter() {
      return this.filters.type[0] !== 1 &&
          this.filters.type[0] !== 2 &&
          this.filters.type[0] !== 3 &&
          this.filters.type[0] !== 6 &&
          this.filters.type[0] !== 13 &&
          this.filters.type[0] !== 14
    },
    showHeightFilter() {
      return this.filters.type[0] !== 1 &&
          this.filters.type[0] !== 2 &&
          this.filters.type[0] !== 3 &&
          this.filters.type[0] !== 6 &&
          this.filters.type[0] !== 13 &&
          this.filters.type[0] !== 14
    },
    showWidthFilter() {
      return this.filters.type[0] !== 1 &&
          this.filters.type[0] !== 2 &&
          this.filters.type[0] !== 3 &&
          this.filters.type[0] !== 6 &&
          this.filters.type[0] !== 13 &&
          this.filters.type[0] !== 14
    },
    showRabbetFilter() {
      return this.filters.type[0] !== 1 &&
          this.filters.type[0] !== 2 &&
          this.filters.type[0] !== 3 &&
          this.filters.type[0] !== 6 &&
          this.filters.type[0] !== 13 &&
          this.filters.type[0] !== 14
    },
    showThicknessFilter() {
      return this.isMatsSelected;
    },
    showDimensionsFilter() {
      return this.isMatsSelected;
    },
    showAcidFreeFilter() {
      return this.isMatsSelected;
    },
    showCollectionFilter() {
      return !this.isMatsSelected &&
          this.filters.type[0] !== 1 &&
          this.filters.type[0] !== 2 &&
          this.filters.type[0] !== 6 &&
          this.filters.type[0] !== 13 &&
          this.filters.type[0] !== 14
    },
    showFinishFilter() {
      return this.filters.type[0] !== 1 &&
          this.filters.type[0] !== 2 &&
          this.filters.type[0] !== 3 &&
          this.filters.type[0] !== 6 &&
          this.filters.type[0] !== 13 &&
          this.filters.type[0] !== 14
    },
    showStyleFilter() {
      return this.filters.type[0] !== 1 &&
          this.filters.type[0] !== 2 &&
          this.filters.type[0] !== 3 &&
          this.filters.type[0] !== 6 &&
          this.filters.type[0] !== 13 &&
          this.filters.type[0] !== 14
    },
    allSubcategoryOptions() {
      let filtersData = this.availableFilters || {};
      let perTypeRows = Array.isArray(filtersData.type)
          ? filtersData.type.flatMap((type) => this.getSubcategoriesForType(type))
          : [];

      if (perTypeRows.length > 0) {
        return perTypeRows;
      }

      if (Array.isArray(filtersData.subcategory)) {
        return this.normalizeSubcategoryRows(filtersData.subcategory);
      }

      return [];
    },
    selectedTypeSubcategories() {
      let selectedTypeValue = this.filters.type[0];
      if (selectedTypeValue === undefined || selectedTypeValue === null || selectedTypeValue === '') {
        return [];
      }

      let typeOptions = Array.isArray(this.availableFilters?.type) ? this.availableFilters.type : [];
      let selectedType = typeOptions.find((type) => parseInt(type.value) === parseInt(selectedTypeValue));
      if (!selectedType) {
        return [];
      }

      return this.getSubcategoriesForType(selectedType);
    },
  },
  methods: {
    normalizeTypeName(value) {
      return (value ?? '').toString().toLowerCase().replace(/[\s_-]+/g, '');
    },
    groupedSubcategoryRows(group) {
      if (!group || typeof group !== 'object') {
        return [];
      }
      if (Array.isArray(group)) {
        return group;
      }
      return group.subcategories || group.subcategory || group.items || group.data || [];
    },
    normalizeSubcategoryRows(rows) {
      if (!Array.isArray(rows)) {
        return [];
      }
      return rows
          .map((row) => {
            let normalizedId = row?.id ?? row?.value ?? row?.subcategory_id;
            let normalizedName = row?.name ?? row?.subcategory_name ?? row?.label;
            if (normalizedId === undefined || normalizedId === null || normalizedId === '') {
              return null;
            }
            return {
              ...row,
              id: normalizedId,
              name: normalizedName || String(normalizedId)
            };
          })
          .filter((row) => row !== null);
    },
    normalizeBasicFilterRows(rows) {
      if (!Array.isArray(rows)) {
        return [];
      }

      return rows
          .map((row) => {
            let normalizedId = row?.id ?? row?.value;
            let normalizedName = row?.name ?? row?.label;
            if (normalizedId === undefined || normalizedId === null || normalizedId === '') {
              return null;
            }
            return {
              ...row,
              id: normalizedId,
              value: normalizedId,
              name: normalizedName || String(normalizedId)
            };
          })
          .filter((row) => row !== null);
    },
    getBasicFilterCount(countMapKey, option) {
      let countMap = this.availableFilters?.[countMapKey];
      let optionId = option?.id ?? option?.value;
      if (countMap && typeof countMap === 'object') {
        let hasNumericKey = Object.prototype.hasOwnProperty.call(countMap, optionId);
        let hasStringKey = Object.prototype.hasOwnProperty.call(countMap, String(optionId));
        let countValue = hasNumericKey ? countMap[optionId] : countMap[String(optionId)];
        if ((hasNumericKey || hasStringKey) && countValue !== undefined && countValue !== null && countValue !== '') {
          return countValue;
        }
      }

      if (option?.count !== undefined && option?.count !== null && option?.count !== '') {
        return option.count;
      }

      if (option?.items_count !== undefined && option?.items_count !== null && option?.items_count !== '') {
        return option.items_count;
      }

      return 0;
    },
    filterLabel(key) {
      if (key === 'type') {
        return 'Products';
      }
      if (key === 'subcategory') {
        return 'Subcategory';
      }
      if (key === 'acid_free') {
        return 'Acid Free';
      }
      if (key === 'dimensions') {
        return 'Size';
      }
      if (key === 'thickness') {
        return 'Thickness';
      }
      return key;
    },
    rowMatchesType(row, normalizedType, normalizedTypeName) {
      let rowTypeId = row.frame_type_id
          ?? row.type_id
          ?? row.frameTypeId
          ?? row.typeId
          ?? row.class_id
          ?? row.classId
          ?? row.parent_id
          ?? row.parentId;
      if (rowTypeId !== undefined && rowTypeId !== null && rowTypeId !== '') {
        return parseInt(rowTypeId) === normalizedType;
      }

      let rowTypeName = this.normalizeTypeName(
          row.frame_type_name
          ?? row.type_name
          ?? row.type
          ?? row.frame_type
          ?? row.frameType
          ?? row.class
          ?? row.parent_name
      );
      if (normalizedTypeName !== '' && rowTypeName !== '') {
        return rowTypeName === normalizedTypeName;
      }

      return false;
    },
    filterRowsForType(rows, normalizedType, normalizedTypeName) {
      if (!Array.isArray(rows)) {
        return [];
      }
      return rows.filter((row) => this.rowMatchesType(row, normalizedType, normalizedTypeName));
    },
    normalizeSearchTerm(value) {
      return (value || '').toString().trim();
    },
    getRouteSearchTerm(route) {
      let query = route && route.query ? route.query : {};
      return this.normalizeSearchTerm(query.topSearch || query.nameSearch || '');
    },
    applyGlobalSearch(term) {
      let searchTerm = this.normalizeSearchTerm(term);
      if (searchTerm === '') {
        return;
      }

      this.searchInputTemp = searchTerm;
      this.suppressAutocompleteSelection = true;
      this.clearWatch = true;
      this.selectedSearch = '';

      let self = this;
      this.clearFilters('', function () {
        self.filters.TopSearch = searchTerm;
        self.searchProducts();
        setTimeout(function () {
          self.suppressAutocompleteSelection = false;
          self.clearWatch = false;
        }, 300);
        setTimeout(function () {
          self.runWatch = true;
        }, 1000);
      });
    },
    getSubcategoriesForType(type) {
      if (!type) {
        return [];
      }

      let filtersData = this.availableFilters || {};
      let subcategoryByType = filtersData.subcategoryByType;
      let normalizedType = parseInt(type.value ?? type.id);
      let normalizedTypeName = this.normalizeTypeName(type.name);
      let subcategories = [];

      if (Array.isArray(subcategoryByType)) {
        subcategories = subcategoryByType.reduce((acc, group) => {
          if (!group) {
            return acc;
          }

          let groupTypeId = group.frame_type_id ?? group.type_id ?? group.type?.value ?? group.frameTypeId ?? group.typeId ?? group.value ?? group.id;
          let groupTypeName = this.normalizeTypeName(group.frame_type_name ?? group.type_name ?? group.type?.name ?? group.name);
          let matchesGroup = parseInt(groupTypeId) === normalizedType;
          if (!matchesGroup && normalizedTypeName !== '' && groupTypeName !== '') {
            matchesGroup = groupTypeName === normalizedTypeName;
          }

          if (matchesGroup) {
            return acc.concat(this.groupedSubcategoryRows(group));
          }
          let rowLevelMatches = this.filterRowsForType(this.groupedSubcategoryRows(group), normalizedType, normalizedTypeName);
          if (rowLevelMatches.length > 0) {
            return acc.concat(rowLevelMatches);
          }
          return acc;
        }, []);
      } else if (subcategoryByType && typeof subcategoryByType === 'object') {
        let directRows = subcategoryByType[normalizedType] || subcategoryByType[String(normalizedType)];
        if (directRows) {
          subcategories = this.groupedSubcategoryRows(directRows);
        }

        if (subcategories.length === 0 && normalizedTypeName !== '') {
          let matchedKey = Object.keys(subcategoryByType).find((key) => this.normalizeTypeName(key) === normalizedTypeName);
          if (matchedKey !== undefined) {
            subcategories = this.groupedSubcategoryRows(subcategoryByType[matchedKey]);
          }
        }

        if (subcategories.length === 0) {
          let flattenedRows = Object.keys(subcategoryByType).flatMap((key) => this.groupedSubcategoryRows(subcategoryByType[key]));
          subcategories = this.filterRowsForType(flattenedRows, normalizedType, normalizedTypeName);
        }
      }

      if (subcategories.length === 0 && Array.isArray(filtersData.subcategory)) {
        subcategories = this.filterRowsForType(filtersData.subcategory, normalizedType, normalizedTypeName);
      }

      return this.normalizeSubcategoryRows(subcategories);
    },
    preventEnter(event) {
      event.preventDefault();
      if (this.searchTimer) {
        clearTimeout(this.searchTimer)
        this.searchTimer = ""
      }
      this.ignoreAutocompleteResults = true;
      this.isLoading = false
      this.options = []
      this.applyGlobalSearch(this.searchInputTemp);
    },
    clearFilters(type, callback) {
      let isFC = this.filters.isFC
      let newfilters = {
        width: [],
        height: [],
        rabbet: [],
        finish: [],
        style: [],
        collection: [],
        thickness: [],
        dimensions: [],
        acid_free: [],
        type: (type !== undefined && type !== '' ? [type] : []),
        Code: "",
        TopSearch: "",
        subcategory: [],
        profile_type: [],
        color_family: [],
        frequently_purchased: [],
        isFC: isFC
      }
      this.runWatch = false;
      this.filters = newfilters
      //this.runWatch = true
      if (callback) {
        callback()
      }
    },
    getFrequentlyPurchased() {
      this.frequently_purchased_active = true
      this.clearFilters()
      this.filters.frequently_purchased.push(true)
    },
    handleSetWidth(value) {
      let inputFromValue = parseInt(value.inputFromValue);
      let selectedFromValue = parseFloat(value.selectedFromValue);
      let from = (!isNaN(inputFromValue) ? inputFromValue : 0) + (!isNaN(selectedFromValue) ? selectedFromValue : 0);

      let inputToValue = parseInt(value.inputToValue);
      let selectedToValue = parseFloat(value.selectedToValue);
      let to = (!isNaN(inputToValue) ? inputToValue : 0) + (!isNaN(selectedToValue) ? selectedToValue : 0);

      if (to <= 0 && from > 0) {
        this.filters.width = [from + '|' + from]
      } else if (to > 0 && from > 0) {
        this.filters.width = [from + '|' + to]
      }
    },
    handleSetHeight(value) {
      let inputFromValue = parseInt(value.inputFromValue);
      let selectedFromValue = parseFloat(value.selectedFromValue);
      let from = (!isNaN(inputFromValue) ? inputFromValue : 0) + (!isNaN(selectedFromValue) ? selectedFromValue : 0);

      let inputToValue = parseInt(value.inputToValue);
      let selectedToValue = parseFloat(value.selectedToValue);
      let to = (!isNaN(inputToValue) ? inputToValue : 0) + (!isNaN(selectedToValue) ? selectedToValue : 0);

      if (to <= 0 && from > 0) {
        this.filters.height = [from + '|' + from]
      } else if (to > 0 && from > 0) {
        this.filters.height = [from + '|' + to]
      }
    },
    handleSetRabbet(value) {
      let inputFromValue = parseInt(value.inputFromValue);
      let selectedFromValue = parseFloat(value.selectedFromValue);
      let from = (!isNaN(inputFromValue) ? inputFromValue : 0) + (!isNaN(selectedFromValue) ? selectedFromValue : 0);

      let inputToValue = parseInt(value.inputToValue);
      let selectedToValue = parseFloat(value.selectedToValue);
      let to = (!isNaN(inputToValue) ? inputToValue : 0) + (!isNaN(selectedToValue) ? selectedToValue : 0);

      if (to <= 0 && from > 0) {
        this.filters.rabbet = [from + '|' + from]
      } else if (to > 0 && from > 0) {
        this.filters.rabbet = [from + '|' + to]
      }
    },
    asyncSearch(query) {
      this.searchInputTemp = query;
      this.ignoreAutocompleteResults = false;
      this.isLoading = true
      if (this.searchTimer) {
        clearTimeout(this.searchTimer)
      }
      let self = this
      this.searchTimer = setTimeout(function () {
        //self.isLoading = false
        self.searchNow(query)
      }, 600);

    },
    searchNow(query) {

      if (query == '') {
        this.isLoading = false
        return
      }
      //this.filters.page = 1
      //todo check for isFC add the type
      this.page = 1;
      this.$store
          .dispatch("product/searchTopData", {
            options: {
              frameType: this.filters.type ? this.filters.type : [],
              TopSearch: query,
              page: 1,
              items_per_page: 10,
              type: this.filters.type ? this.filters.type : []
            }
          })
          .then(rez => {
            if (this.ignoreAutocompleteResults) {
              this.isLoading = false
              return
            }
            this.runWatch = false
            //this.filters.type = []
            let self = this
            setTimeout(function () {
              self.runWatch = true
            }, 1000)
            this.options = rez
            this.isLoading = false
          });
    },
    isArray(value) {
      return Array.isArray(value);
    },
    onEnterPressed() {
      this.filters.Code = this.searchCode;
    },
    imageUrl(item) {
      let loc = process.env.VUE_APP_CDN + "/frames/" + item.Code + "/" + item.Code + "-small.jpg";
      if (item.FrameType === 'MATS') {
        loc = process.env.VUE_APP_CDN + "/mat/" + item.ManufCode + "/" + item.ManufCode + "-small.jpg";
      }
      return loc;
    },
    imageUrlAlt(event) {
      event.target.src = this.defaultImg;
    },
    setAcidFreeFilter(value) {
      this.filters.acid_free = [value];
    },
    clearAcidFreeFilter() {
      this.filters.acid_free = [];
    },
    filterByValue(key, val) {
      if (key === 'width' || key === 'rabbet' || key === 'height') {
        let eachVal = val.split('|');
        return this.widthFracDen(eachVal[0]) + ' - ' + this.widthFracDen(eachVal[1])
      } else if (key === 'subcategory') {
        let options = this.allSubcategoryOptions;
        let obj = options.find((o) => String(o.value) === String(val) || String(o.id) === String(val));
        return obj !== undefined ? obj.name : "";
      } else if (key === 'acid_free') {
        if (parseInt(val) === 1) {
          return 'Yes';
        }
        if (parseInt(val) === 0) {
          return 'No';
        }
        return '';
      } else if (key === 'thickness' || key === 'dimensions') {
        let options = this.normalizeBasicFilterRows(this.availableFilters[key]);
        let obj = options.find((o) => String(o.value) === String(val) || String(o.id) === String(val));
        return obj !== undefined ? obj.name : "";
      } else {
        if (this.availableFilters[key] !== undefined) {
          let obj = this.availableFilters[key].find((o) => String(o.value) === String(val) || String(o.id) === String(val));
          return obj !== undefined ? obj.name : "";
        }
      }
    },
    getSubcategoryCount(subcategory) {
      let filtersData = this.availableFilters || {};
      let countMap = filtersData.subcategoryCount;
      if (countMap && typeof countMap === 'object') {
        let hasNumericKey = Object.prototype.hasOwnProperty.call(countMap, subcategory.id);
        let hasStringKey = Object.prototype.hasOwnProperty.call(countMap, String(subcategory.id));
        let countValue = hasNumericKey ? countMap[subcategory.id] : countMap[String(subcategory.id)];
        if ((hasNumericKey || hasStringKey) && countValue !== undefined && countValue !== null && countValue !== '') {
          return countValue;
        }
      }

      if (subcategory.items_count !== undefined && subcategory.items_count !== null && subcategory.items_count !== '') {
        return subcategory.items_count;
      }

      return 0;
    },
    removeFilterByValue(key, val) {
      if (key === "Code" || key === "TopSearch") {
        this.filters[key] = "";
        this.selectedSearch = "";
        this.isLoading = false
      } else {
        if (Array.isArray(this.filters[key])) {
          this.filters[key].splice(this.filters[key].indexOf(val), 1);
        } else {
          this.filters[key] = "";
        }
      }
    },
    search(data) {
      this.filters = {...this.filters, ...data};
    },
    fbimgCheck() {
      if (!this.isFrameBuilder) {
        return '';
      }
      return this.filters.type == 1 ? false : this.isFrameBuilder
    },
    searchProducts() {
      let requestOptions = {
        ...this.filters,
        page: 1,
        fbimg: this.fbimgCheck(),
        frame_creator_active: this.fbimgCheck() ? true : 'all',
        items_per_page: this.perPage,
      }
      let requestKey = JSON.stringify(requestOptions)
      if (this.isMainSearchInFlight && this.activeMainSearchKey === requestKey) {
        return
      }

      //this.filters.page = 1
      this.infShowLoader = true
      this.isMainSearchInFlight = true
      this.activeMainSearchKey = requestKey
      this.page = 1;
      this.$store
          .dispatch("product/getProductData", {
            options: requestOptions,
            clear: true,
          })
          .then(data => {
            this.hasMore = data?.next_page_url == null ? false : true
            this.totalResults = data.total
            this.infShowLoader = false
            this.isLoading = false
            if (this.Open == 'Y' && !this.hasOpen) {
              if (data.data[0] !== undefined) {
                this.addToCart(data.data[0]);
                this.hasOpen = true;
              }
            }
            if (this.filters.frequently_purchased[0]) {
              this.removeInfScroll();
              this.runWatch = false
              this.filters.frequently_purchased = []
              let self = this
              setTimeout(function () {
                self.runWatch = true
              }, 1000)
            } else {
              this.loadInfScroll();
            }
          })
          .finally(() => {
            if (this.activeMainSearchKey === requestKey) {
              this.isMainSearchInFlight = false
              this.activeMainSearchKey = ""
            }
          });
    },
    closeModal() {
      this.myModal.hide();
    },
    boRespond() {
      this.backorderModal.hide()
      this.frameMouldingBuilderSubmit(this.thisSaveItem);
    },
    frameMouldingBuilder(item) {
      if (this.isLoggedin) {
        this.$store.dispatch('product/getProductLocationQty', item.Code).then(data => {
          let pLocQty = data.LocationQty
          let onHand = 0;
          let inStock = false;
          Object.keys(pLocQty).forEach(key => {
            onHand = parseFloat(pLocQty[key].Onhand)
            if (1 > onHand) {
              console.log('not in stock')
            } else {
              inStock = true;
            }
          });
          if (inStock) {
            this.frameMouldingBuilderSubmit(item);
          } else {
            //display popup
            this.thisSaveItem = item
            this.backorderModal.show()
          }
        });
      } else {
        this.frameMouldingBuilderSubmit(item);
      }

    },
    frameMouldingBuilderSubmit(item) {
      item.id = item.Code;
      let obj = {};
      if (item.FrameType === "MATS") {
        obj.mat = item;
      } else if (item.FrameType === "GLASS") {
        obj.glass = item;
      } else {
        obj.moulding = item;
        obj.fSize = item.Width;
      }
      this.$emit("frameBuilder", obj);
    },
    addToCart(item) {
      this.detailCode = item.Code;
      this.$refs.cartD.loadProductDetails(item.Code);
      this.myModal.show();
      this.detailImg = this.imageUrl(item);
      //this.$router.push({name: 'productDetail', params: {Code}})
    },
    clearDetails() {
      this.detailData = {};
      this.detailImg = "";
      this.details = {};
    },
    shopDetail(item) {
      //todo do stuff with this.
      if (this.isLoggedin) {
        this.$refs.cartD.loadProductDetails(item.Code);
      }
      item.widthFrac = this.widthFrac(item.Width);
      this.detailImg = this.imageUrl(item);
      this.details = item;
      this.detailModal.show();
    },
    returnData(data) {
      this.detailData = data
    },
    widthFracDen(decWidth) {
      let f = new Fraction(decWidth);
      let res = f.toFraction(true);

      return res;
    },
    widthFrac(decWidth) {
      let f = new Fraction(decWidth);
      let res = f.toFraction(true);
      let resx = res.split(" ");

      let den = "";
      if (resx[1] !== undefined) {
        den = resx[1];
      }
      let fr = resx[0] + ' ' + den;
      return fr.replace(/\s+$/, '') + '"';
    },
    removeInfScroll() {
      window.onscroll = null
    },
    loadNextPage() {
      this.infShowLoader = true
      this.page = this.page + 1;
      this.$store
          .dispatch("product/getProductData", {
            options: {
              ...this.filters,
              page: this.page,
              fbimg: this.fbimgCheck(),
              frame_creator_active: this.fbimgCheck() ? true : 'all',
              items_per_page: this.perPage,
            },
          })
          .then(data => {
            this.hasMore = data?.next_page_url == null ? false : true
            this.infShowLoader = false
            this.totalResults = data.total
          });
    },
    loadInfScroll() {
      if (window.onscroll === null) {
        window.onscroll = () => {
          let bottomOfWindow =
              document.documentElement.scrollTop + window.innerHeight ===
              document.documentElement.offsetHeight;

          if (bottomOfWindow) {
            this.loadNextPage();
          }
        };
      }
      let self = this
      const modal = document.querySelector(".modal-body");
      modal.addEventListener("scroll", function () {
        if (modal.scrollTop + modal.clientHeight >= modal.scrollHeight) {
          self.loadNextPage();
        }
      });
    },
  },

  mounted() {
    let routeSearchTerm = this.getRouteSearchTerm(this.$route);
    if (routeSearchTerm !== '') {
      this.hasQuery = true;
    }

    if (this.Code !== undefined && this.Code != "") {
      this.filters.type = [];
      this.filters.Code = this.Code;
    } else if (!this.hasQuery) {
      //set default
      this.runWatch = false
      this.filters.type = [4]
    }

    if (this.$route.query.collection !== undefined && Object.keys(this.$route.query.collection).length !== 0) {
      this.hasQuery = true
      if (!Array.isArray(this.$route.query.collection)) {
        this.$route.query.collection = [this.$route.query.collection]
      }

      this.filters.collection = this.$route.query.collection.map(function (element) {
        return parseInt(element);
      });
    }

    if (routeSearchTerm !== '' && !(this.Code !== undefined && this.Code !== "")) {
      this.applyGlobalSearch(routeSearchTerm);
    }
    this.myModal = new Modal(document.getElementById("cartModal"));
    this.detailModal = new Modal(document.getElementById("shopDModal"));
    this.backorderModal = new Modal(document.getElementById("backOrderModal"));
    this.$store.dispatch("product/getFilters", {options: {}}).then(() => {
      this.loadInfScroll()
    })
  }
};
</script>

<style scoped>

.shop-search-input {
  margin-bottom: 10px;
}

.form-check-input {
  border-color: #000000;
}

.accordion-button-cust {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 1rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}

.dispH {
  height: 30px;
}

.codeFS {
  font-size: 2.8vh;
}


</style>
